export default __webpack_public_path__ + "static/media/trr-event-party.dd0e634f.png";